import { Card, Typography, Chip, Stack } from "@mui/material";
import { Box } from "@mui/system";
import {
  colors,
  spacing,
  typography,
} from "../../../../../../../../../../assets/styles/tokens";
import {
  cleanNumber,
  formatUsd,
  formatDate,
} from "../../../../../../../DashboardDesktop/Anomalies/AnomaliesTabs/Utils/anomaliesColumns";

// ─────────────────────────────────────────────────────────────────────────────

// Gap indicator per spec: red when gap <= -1000 or gap >= 1000.
const isGapHighlighted = (value: any) => {
  const num = cleanNumber(value);
  return num <= -1000 || num >= 1000;
};

interface DailyEarningsGapsCardProps {
  row: Record<string, any>;
}

const GapChip = ({ value }: { value: any }) => {
  const isHighlighted = isGapHighlighted(value);
  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Chip
        label={formatUsd(value)}
        size="medium"
        sx={{
          borderRadius: spacing.Radius.xs.$value,
          fontSize: typography.Size.Text.md.$value,
          bgcolor: isHighlighted
            ? colors.Error[50].$value
            : colors.GrayLightMode[100].$value,
          color: isHighlighted
            ? colors.Error[600].$value
            : colors.GrayLightMode[900].$value,
          fontWeight: typography.Font_weight.Semibold.$value,
        }}
      />
      <Typography
        variant="body1"
        sx={{
          fontSize: typography.Size.Text.sm.$value,
          color: colors.GrayLightMode[900].$value,
          mx: spacing.Spacing.xs.$value,
        }}
      >
        Gap on:
      </Typography>
    </Box>
  );
};

export function DailyEarningsGapsCard({ row }: DailyEarningsGapsCardProps) {
  return (
    <Card
      sx={{
        p: 1,
        borderRadius: spacing.Radius.lg.$value,
        boxShadow: "0px 1px 2px #0A0D120F , 0px 1px 3px #0A0D121A",
        border: "1px solid" + colors.GrayLightMode[200].$value,
        mb: spacing.Spacing.none.$value,
        mt: spacing.Spacing.xl.$value + "!important",
      }}
    >
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography
          variant="body1"
          sx={{
            color: colors.GrayLightMode[700].$value,
            fontSize: typography.Size.Text.xs.$value,
            fontWeight: typography.Font_weight.Medium.$value,
            mb: spacing.Spacing.md.$value,
          }}
        >
          {row.brand_name} ({row.brand_id})
        </Typography>
      </Stack>

      <Stack sx={{ flexDirection: "row", alignItems: "center" }}>
        <GapChip value={row.gap} />
        <Box
          component="span"
          sx={{
            fontSize: typography.Size.Text.sm.$value,
            fontWeight: typography.Font_weight.Medium.$value,
            ml: spacing.Spacing.xs.$value,
          }}
        >
          {formatDate(row.brand_action_date)}
        </Box>
      </Stack>

      <Stack
        direction="row"
        justifyContent="space-between"
        mt={spacing.Spacing.xs.$value}
        mb={spacing.Spacing.md.$value}
      >
        <Box
          sx={{
            width: "50%",
            borderRight: "1px solid" + colors.GrayLightMode[200].$value,
            pr: spacing.Spacing.md.$value,
          }}
        >
          <Typography
            mb={spacing.Spacing.xs.$value}
            sx={{
              color: colors.GrayLightMode[500].$value,
              fontSize: typography.Size.Text.xs.$value,
            }}
          >
            Previous Total Income
          </Typography>
          <Typography
            sx={{
              color: colors.GrayLightMode[900].$value,
              fontSize: typography.Size.Text.md.$value,
              fontWeight: typography.Font_weight.Semibold.$value,
              pr: spacing.Spacing.xs.$value,
            }}
          >
            {formatUsd(row.past_totalincome)}
          </Typography>
        </Box>
        <Box sx={{ width: "50%", pl: spacing.Spacing.md.$value }}>
          <Typography
            mb={spacing.Spacing.xs.$value}
            sx={{
              color: colors.GrayLightMode[500].$value,
              fontSize: typography.Size.Text.xs.$value,
            }}
          >
            Current Total Income
          </Typography>
          <Typography
            sx={{
              color: colors.GrayLightMode[900].$value,
              fontSize: typography.Size.Text.md.$value,
              fontWeight: typography.Font_weight.Semibold.$value,
              pr: spacing.Spacing.xs.$value,
            }}
          >
            {formatUsd(row.now_totalincome)}
          </Typography>
        </Box>
      </Stack>

      <Stack>
        <Typography
          variant="body1"
          sx={{
            fontSize: typography.Size.Text.sm.$value,
            color: colors.GrayLightMode[900].$value,
          }}
        >
          Updated on:
          <Box
            component="span"
            sx={{
              fontSize: typography.Size.Text.sm.$value,
              fontWeight: typography.Font_weight.Medium.$value,
              ml: spacing.Spacing.xs.$value,
            }}
          >
            {formatDate(row.captured_date)}
          </Box>
        </Typography>
      </Stack>
    </Card>
  );
}
export default DailyEarningsGapsCard;
